import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser, FaChevronRight, FaChevronLeft } from "react-icons/fa";
import { useFetchDashboardTaskDetailsQuery } from "../../slice/logdetailSlice";
import Loader from "../common/Loader";
import { useSelector } from "react-redux";

const ITEMS_PER_PAGE = 10;
const TaskItem = ({
  taskName,
  taskId,
  project_id,
  ownerName,
  projectName,
  status,
  color,
}) => {
  const navigate = useNavigate();

  const handleTaskClick = () => {
    navigate(`/projects/projectDetail/${project_id}/taskdetail/${taskId}`);
  };
  // navigate(`/projects/projectDetail/${project_id}/tasks`);

  return (
    <div
      className="card bg-white border-0 rounded-bottom-0"
      style={{ cursor: "pointer" }}
      onClick={handleTaskClick}
    >
      <div className="card-body p-0">
        <h6 className=" font-bold">{taskName}</h6>
        <div className="row">
          <div className="col-md-3 text-rgba-gray">{projectName}</div>
          <div
            className="col-md-6 d-flex align-items-center  mb-2"
            style={{ color: "rgba(98, 97, 97, 1)" }}
          >
            <FaUser className="me-2" style={{ color: "rgba(98, 97, 97, 1)" }} />
            Owner
            <span style={{ color: "rgba(98, 97, 97, 1)" }} className="ms-3">
              {ownerName}
            </span>
          </div>
          <div className="col-md-3">
            <p style={{ color: color || "black" }}>{status}</p>
          </div>
        </div>
      </div>
      <hr />
    </div>
  );
};

const ProjectCard = ({
  projectName,
  ownerName,
  progress,
  projectId,
  tasks,
}) => {
  const navigate = useNavigate();
  const {
    data: task_details,
    isLoading: task_loading,
    refetch: task_details_refetch,
  } = useFetchDashboardTaskDetailsQuery();
  const [currentPage, setCurrentPage] = useState(1);
  //console.log("task_details (before slicing):", task_details);
  // //console.log("task_details (after slicing):", task_details?.slice(0, 5));
  // RTK Query automatically fetches on mount; redundant refetch on mount removed
  const totalTasks = task_details?.length || 0;
  const totalPages = Math.ceil(totalTasks / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const paginatedTasks = task_details?.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };
  return (
    <>
      {task_loading ? (
        <Loader />
      ) : (
        <div>
          {paginatedTasks?.length > 0 ? (
            paginatedTasks.map((task, index) => (
              <TaskItem
                key={index}
                taskName={task.name}
                taskId={task.id}
                projectId={task.project_id}
                // ownerName={task.owners[0].name}
                // ownerName={task.owners[0].name}
                ownerName={task.owners && task.owners[0] ? task.owners[0].name : ""}
                status={task.status_name}
                color={task.status_colour}
                projectName={task.project_name}
                project_id={task.project_id}
              />
            ))
          ) : (
            <p>No tasks available</p>
          )}

          {/* Pagination */}

          {totalPages > 1 && (
            // <div className="d-flex justify-content-end align-items-center mt-3">
            //   <button
            //     className="dashNextBtn"
            //     onClick={handlePrev}
            //     disabled={currentPage === 1}
            //   >
            //     <FaChevronLeft /> Prev
            //   </button>
            //   <span className="mx-2">
            //     Page {currentPage} of {totalPages}
            //   </span>
            //   <button
            //     className="dashNextBtn"
            //     onClick={handleNext}
            //     disabled={currentPage === totalPages}
            //   >
            //     Next <FaChevronRight />
            //   </button>
            // </div>
            <div className="d-flex justify-content-end align-items-center mt-3">
              <FaChevronLeft
                onClick={currentPage === 1 ? null : handlePrev}
                className={`mx-2 ${currentPage === 1
                    ? "text-muted pointer-events-none"
                    : "cursor-pointer"
                  }`}
                style={{
                  opacity: currentPage === 1 ? 0.3 : 1,
                  cursor: currentPage === 1 ? " not-allowed " : "pointer",
                }}
              />
              <span className="mx-2">{`Page ${currentPage} of ${totalPages}`}</span>
              <FaChevronRight
                onClick={currentPage === totalPages ? null : handleNext}
                className={`mx-2 ${currentPage === totalPages
                    ? "text-muted pointer-events-none"
                    : "cursor-pointer"
                  }`}
                style={{
                  opacity: currentPage === totalPages ? 0.3 : 1,
                  cursor:
                    currentPage === totalPages ? " not-allowed " : "pointer",
                }}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export const MyTasks = ({ projects_task, onSeeMore }) => {
  const { data: task_details, isLoading: task_loading } =
    useFetchDashboardTaskDetailsQuery();
  const totalTasks = task_details?.length || 0;
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  //console.log("login_user in pproject:", login_user);
  // const { role: login_user_role } = login_user;
  const { role: login_user_role } = login_user || {};
  return (
    <>
      {task_loading ? (
        <Loader />
      ) : (
        <div className="container tableScroll bg-white p-3 rounded-3">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <div className="d-flex align-items-center ">
              <h5 className="cardsub_title mb-0 pe-3">
                {login_user_role === "ADMIN" || login_user_role === "CLIENT"
                  ? "All Tasks"
                  : "My Tasks"}
              </h5>{" "}
              <div className="cardsub_title_line"></div>
            </div>
            <div className="text-rgba-gray">
              Total Tasks: <strong>{totalTasks}</strong>
            </div>
            {/* <button className="btn btn-link p-0" onClick={onSeeMore}>
          See More
        </button> */}
          </div>
          {/* {projects_task.map((projects_task, index) => ( */}
          <ProjectCard
          // key={index}
          // projectName={projects_task.name}
          // ownerName={projects_task.owner}
          // progress={projects_task.progress}
          // projectId={projects_task.id}
          // tasks={projects_task.tasks}
          />
        </div>
      )}
    </>
  );
};
